import logo from './logo.svg';
import './App.css';

// import Login from "./Pages/Login"
// import Signup from "./Pages/Signup"
// import {Home} from './Pages/Home'
import Allroutes from './AllRoutes/Allroutes';


function App() {
  return (
    <div className="App">
      <Allroutes/>
    </div>
  );
}

export default App;
